import React from "react";
import * as styles from "./sidebar-tooltip.module.scss";
import { classArr } from "../../helper/style-helper";

export type SidebarTooltipAlignment = "top" | "middle" | "bottom";

export interface SidebarTooltipProps {
	alignment?: SidebarTooltipAlignment;
	children?: string | React.ReactNode;
	verticalNudge?: number;
}

export default function SidebarTooltip(props: SidebarTooltipProps) {
	const alignment: SidebarTooltipAlignment = props.alignment ?? "middle";

	let tooltipAlignmentClass: string;
	switch (alignment) {
		case "top":
			tooltipAlignmentClass = styles.tooltipTop;
			break;
		case "middle":
			tooltipAlignmentClass = styles.tooltipMiddle;
			break;
		case "bottom":
			tooltipAlignmentClass = styles.tooltipBottom;
			break;
	}

	// The barrier is to allow easy traversal of the mouse from the icon to the tooltip
	// without accidentally hovering over the backdrop and closing the tooltip
	return (
		<>
			<div className={styles.barrier}></div>
			<svg
				className={styles.arrow}
				width="4"
				height="8"
				viewBox="0 0 1 2"
			>
				<polygon points="1,0 1,2 0,1" fill="#00255D" />
			</svg>
			<span
				style={{
					marginTop: props.verticalNudge
						? `${props.verticalNudge}px`
						: undefined,
					marginBottom: props.verticalNudge
						? `${-props.verticalNudge}px`
						: undefined,
				}}
				className={classArr(
					styles.tooltip,
					tooltipAlignmentClass,
					styles.tooltipContainer,
				)}
			>
				{props.children}
			</span>
		</>
	);
}
